<template>
  <div v-if="menu.Categories" class="row">
    <div class="col-sm-12 pr-spc" v-if="menu.Categories.length > 0">
      <!-- combos category -->
      <section
        v-for="category in menu.Categories"
        :key="category.ID"
        :id="'section-' + category.ID"
      >
        <div class="row">
          <div id="combos" class="category-title" :style="getStyle()">{{ category.Name }}</div>
        </div>
        <div v-for="product in category.SubMenuItems" :key="product.ID" class="row">
          <Product
            :product="menu.Products[product.ProductID]"
            :modifiers="menu.ModifierGroups"
            :category="product"
            :key="product.ID"
          />
        </div>
      </section>
    </div>
    <div v-else>
      <message />
    </div>
  </div>
</template>

<script>
import Product from "./ProductMobile";
import { mapGetters } from "vuex";
import Message from "../../shared/Message";
export default {
  name: "ProductList",
  components: { Product, Message },
  props: {
    menu: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(["mobileStyles"])
  },
  methods: {
    getStyle() {
      var style = [];
      style.push(this.mobileStyles.primaryBackgroundColour);
      style.push(this.mobileStyles.primaryColourImportant);
      return style;
    }
  }
};
</script>
